var map = {
	"./kotor/en": [
		1338,
		338
	],
	"./kotor/en.tsx": [
		1338,
		338
	],
	"./stavanger/en": [
		2782,
		782
	],
	"./stavanger/en.tsx": [
		2782,
		782
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6429;
module.exports = webpackAsyncContext;